import { IExperiment, TExperimentsState } from '../../types/experiments';

export function getExperiment(experiments: TExperimentsState, experimentName: string): IExperiment | undefined {
  return experimentName in experiments ? { experimentName, group: experiments[experimentName] } : undefined;
}

export function isExperimentActive(experiments: TExperimentsState, experimentName: string, group: string): boolean {
  const experiment = getExperiment(experiments, experimentName);

  if (!experiment) {
    return false;
  }

  return experiment.group === group;
}

export function experimentsArray(experiments: TExperimentsState): IExperiment[] {
  return Object.entries(experiments).map(([experimentName, group]) => ({ experimentName, group }));
}
